import { render } from "./customerData.vue?vue&type=template&id=8d4cbc7c&ts=true"
import script from "./customerData.vue?vue&type=script&lang=ts"
export * from "./customerData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__